// Top-level routes. Each surface is one lazily loaded module:
//   /, /events/:id     dashboard (signed in)     /login       sign-in
//   /kiosk/:token      the iPad check-in screen  /wall/:token welcome wall (venue TV)
//   /pass/:guestId     a guest's QR pass (their phone)
import { Center, Loader } from "@mantine/core";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";

const LoginPage = lazy(() => import("./dashboard/LoginPage"));
const DashboardApp = lazy(() => import("./dashboard/DashboardApp"));
const KioskPage = lazy(() => import("./kiosk/KioskPage"));
const WallPage = lazy(() => import("./wall/WallPage"));
const PassPage = lazy(() => import("./pass/PassPage"));

function Loading() {
  return (
    <Center h="100dvh">
      <Loader />
    </Center>
  );
}

export function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/kiosk/:token" element={<KioskPage />} />
        <Route path="/wall/:token" element={<WallPage />} />
        <Route path="/pass/:guestId" element={<PassPage />} />
        <Route path="/*" element={<DashboardApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
